"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("../../../Button/Button"));
var DateField_1 = __importDefault(require("../../../Form/fields/DateField"));
var SelectTypOdmitnuti_1 = __importDefault(require("../../../Form/fields/SelectTypOdmitnuti"));
var TextField_1 = __importDefault(require("../../../Form/fields/TextField"));
var Form_1 = __importDefault(require("../../../Form/Form"));
var Padder_1 = require("../../../Padder");
var ModalButtonsWrap_1 = __importDefault(require("../ModalButtonsWrap"));
var PopupHeader_1 = __importDefault(require("../PopupHeader"));
var validation = function (values) {
    var datumLens = ramda_1.lensPath(['odmitnuti', 'datum']);
    var typLens = ramda_1.lensPath(['odmitnuti', 'idTypOdmitnuti']);
    var pipe1 = ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(datumLens, values); }, ramda_1.set(datumLens, 'Datum odmítnutí je povinné')), ramda_1.when(function () { return !ramda_1.view(typLens, values); }, ramda_1.set(typLens, 'Důvod odmítnutí je povinný')))({});
    return Object.keys(pipe1).length > 0 ? __assign(__assign({}, pipe1), { dot: '' }) : pipe1;
};
var OdmitnutiUkonuForm = function (_a) {
    var onSubmit = _a.onSubmit, initialValues = _a.initialValues, headerText = _a.headerText, onZrusit = _a.onZrusit;
    return (react_1.default.createElement(Form_1.default, { initialValues: initialValues || {}, validate: validation, onSubmit: onSubmit }, function (_a) {
        var isSubmitting = _a.isSubmitting;
        return (react_1.default.createElement(Padder_1.Padder, null,
            react_1.default.createElement(PopupHeader_1.default, null, headerText),
            react_1.default.createElement(DateField_1.default, { label: "Datum odm\u00EDtnut\u00ED:", name: "odmitnuti.datum", toolTip: "Vyberte datum odm\u00EDtnut\u00ED" }),
            react_1.default.createElement(SelectTypOdmitnuti_1.default, { label: "D\u016Fvod odm\u00EDtnut\u00ED:", name: "odmitnuti.idTypOdmitnuti", inputId: "SelectTypOdmitnuti" }),
            react_1.default.createElement(TextField_1.default, { label: "Odm\u00EDtnut\u00FD \u00FAkon:", name: "odmitnuti.oznaceniUkon", toolTip: "Vypl\u0148te odm\u00EDtnut\u00FD \u00FAkon", maxLength: 400 }),
            react_1.default.createElement(ModalButtonsWrap_1.default, null,
                react_1.default.createElement(Button_1.default, { type: "button", primary: false, loading: isSubmitting, onClick: onZrusit, name: "Zrusit" }, "Zru\u0161it"),
                react_1.default.createElement(Button_1.default, { type: "submit", primary: true, loading: isSubmitting, name: "Ulozit" }, "Ulo\u017Eit"))));
    }));
};
OdmitnutiUkonuForm.defaultProps = {
    initialValues: undefined,
};
exports.default = OdmitnutiUkonuForm;
